"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsIdentifierNamesCache = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const class_validator_1 = require("class-validator");
const Default_1 = require("../presets/Default");
const validateDictionary = (value) => {
    if (value === undefined) {
        return true;
    }
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    const objectValues = Object.values(value);
    if (!objectValues.length) {
        return true;
    }
    for (const objectValue of objectValues) {
        if (typeof objectValue !== 'string') {
            return false;
        }
    }
    return true;
};
function IsIdentifierNamesCache(validationOptions) {
    return (optionsObject, propertyName) => {
        (0, class_validator_1.registerDecorator)({
            propertyName,
            constraints: [],
            name: 'IsIdentifierNamesCache',
            options: validationOptions,
            target: optionsObject.constructor,
            validator: {
                validate(value, validationArguments) {
                    const defaultValue = Default_1.DEFAULT_PRESET[propertyName];
                    const isDefaultValue = (0, fast_deep_equal_1.default)(value, defaultValue);
                    if (isDefaultValue || value === null) {
                        return true;
                    }
                    if (typeof value !== 'object') {
                        return false;
                    }
                    if (!validateDictionary(value === null || value === void 0 ? void 0 : value.globalIdentifiers)) {
                        return false;
                    }
                    return validateDictionary(value === null || value === void 0 ? void 0 : value.propertyIdentifiers);
                },
                defaultMessage() {
                    return 'Passed value must be an identifier names cache object or `null` value';
                }
            }
        });
    };
}
exports.IsIdentifierNamesCache = IsIdentifierNamesCache;
